import React from "react";
import "./OperationalUI.css";

export default function TopToolbar({


  showSquawkPanel,
  setShowSquawkPanel,


  isFlightActive,
  onZoomToDestination,


  drawingMode,
  setDrawingMode,

  canvasRef,

  setShowChartBrowser,
  showChartBrowser,

  setShowChartsPanel,
  showChartsPanel,

  showPirepForm,
  setShowPirepForm,



}) {

const clearDrawing = () => {

  console.log(
    "🚨 CLEAR",
    canvasRef.current
  );

  const canvas =
    canvasRef.current;

  if (!canvas) return;

  const ctx =
    canvas.getContext("2d");

  ctx.clearRect(
    0,
    0,
    canvas.width,
    canvas.height
  );
};

  return (

    <div className="top-toolbar">

  {/* 🎯 DESTINATION — ACTIVE FLIGHT ONLY */}
{isFlightActive && (
  <button
    className="op-btn"
    onClick={onZoomToDestination}
  >
    🎯 Destination
  </button>
)}    

{/* 📝 PIREP */}
<button
  className={`op-btn ${
    showPirepForm
      ? "active"
      : ""
  }`}
  onClick={() => {

    // Toggle PIREP window:
    // closed -> open
    // open   -> closed
    setShowPirepForm(
      prev => !prev
    );

  }}
>
  📝 PIREP
</button>

      {/* ✏️ DRAW */}
      <button
        className={`op-btn ${
          drawingMode ? "active" : ""
        }`}
        onClick={() =>
          setDrawingMode(
            !drawingMode
          )
        }
      >
        ✏️ Draw
      </button>

      {/* 🧹 CLEAR */}
<button
  className="op-btn"
  onClick={() => {
    console.log("🚨 CLEAR BUTTON CLICKED");
    clearDrawing();
  }}
>
  🧹 Clear
</button>



      {/* 📄 CHARTS */}
      <button
        className={`op-btn ${
          showChartsPanel
            ? "active"
            : ""
        }`}
        onClick={() =>
          setShowChartsPanel(
            prev => !prev
          )
        }
      >
        📄 Charts
      </button>

      {/* 🔍 BROWSE */}
      <button
        className={`op-btn ${
          showChartBrowser
            ? "active"
            : ""
        }`}
        onClick={() =>
          setShowChartBrowser(
            prev => !prev
          )
        }
      >
        🔍 Browse
      </button>

      {/* 🐞 SQUAWK */}
<button
  className={`op-btn ${
    showSquawkPanel
      ? "active"
      : ""
  }`}
  onClick={() => {

    setShowSquawkPanel(
      prev => !prev
    );

  }}
>
  🐞 SQUAWK
</button>




    </div>
  );
}